var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossedEyeIcon = function SvgCrossedEyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 17 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#CrossedEyeIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.25 6.84-1 .66c.141.27.323.516.54.73l1.11-.72a2 2 0 0 1-.65-.67M8.1 2.66a3.3 3.3 0 0 0-1.83.56A3.4 3.4 0 0 0 5.05 4.7a3.3 3.3 0 0 0-.24 1.31l1.49-1a1.7 1.7 0 0 1 .37-.51 2 2 0 0 1 1-.56q.14-.007.28 0l1.49-1a3.4 3.4 0 0 0-1.34-.28M3.37 8.73l-1.12.77q.341.333.73.61l1.14-.74a9 9 0 0 1-.75-.64M8.1 9.26a3.3 3.3 0 0 0 1.27-.25 3.26 3.26 0 0 0 2-2.6L7.19 9.13l.27.07q.318.06.64.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.25 8.33 1.07-.7a7 7 0 0 1-1-1.67 7.88 7.88 0 0 1 6.78-4.7 6.7 6.7 0 0 1 2.91.73l1.21-.8A8.59 8.59 0 0 0 .04 5.75a.64.64 0 0 0 0 .43 9 9 0 0 0 1.21 2.15M16.17 5.75a10 10 0 0 0-1-1.82l-1.06.69q.456.627.76 1.34a7.87 7.87 0 0 1-6.79 4.7 6.6 6.6 0 0 1-2.46-.53l-1.28.83a8.64 8.64 0 0 0 11.81-4.78.64.64 0 0 0 0-.43zM9.64 4.66c0 .06.11.11.15.17a1.9 1.9 0 0 1 .27.64l1.11-.72a3.3 3.3 0 0 0-.46-.79zM13.55 2.12l-1.13.74q.377.285.72.61l1.1-.71a8 8 0 0 0-.69-.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.95 1.21.48 10.61a.44.44 0 0 0-.13.62.47.47 0 0 0 .63.14l14.47-9.4a.47.47 0 0 0 .2-.28.46.46 0 0 0-.7-.48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CrossedEyeIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16.2v11.93H0z"
  })))));
};
export default SvgCrossedEyeIcon;